import React from "react";
import CancelMaterialIcon from "@components/Svg/CancelMaterialIcon";
import { digitalKeyBoardPattern } from "@utils/utils";
import { MaterialTextInputProps } from "./types";
import classes from "./MaterialTextInput.module.scss";

const MaterialTextInput = ({
    label,
    postfix,
    onInput,
    onChange,
    value,
    style,
    disabled,
    type,
    maxLength,
    customButton,
    onCustomButtonClick,
    preventAutocomplete = false
}: MaterialTextInputProps) => {
    const onChangeHandler = (val: React.ChangeEvent<HTMLInputElement>) => {
        if (type === "number") {
            onChange?.(val.target.value.replace(/\D/g, ""));
        } else {
            onChange?.(val.target.value);
        }
    };

    return (
        <div
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    onCustomButtonClick?.(e);
                }
            }}
            style={style}
            className={classes.MaterialTextInput}
        >
            <div className={classes.InputCont}>
                <>
                    <input
                        disabled={disabled}
                        maxLength={maxLength}
                        onChange={onChangeHandler}
                        onInput={onInput}
                        type={"text"}
                        pattern={type === "number" ? digitalKeyBoardPattern : undefined}
                        inputMode={type === "number" ? "numeric" : undefined}
                        id="fname"
                        name="fname"
                        value={value}
                        aria-labelledby="placeholder-fname"
                        autoComplete={preventAutocomplete ? "off" : undefined}
                    />
                    <label className={classes.PlaceholderText} id="placeholder-fname">
                        <div className={classes.Text}>{label}</div>
                    </label>

                    {postfix && <div className={classes.Postfix}>{postfix}</div>}
                </>
            </div>
            {customButton && (
                <div className={classes.CustomButton} onClick={onCustomButtonClick}>
                    {customButton}
                </div>
            )}
            {!customButton && value.length > 0 && !disabled && (
                <CancelMaterialIcon
                    onClick={() => {
                        onChange?.("");
                    }}
                />
            )}
        </div>
    );
};
export default MaterialTextInput;